import { api, ApiError, newRequestId } from '../../shared/api';

/** One intentional write, including recovery after the server may already have committed. */
export class WarehouseWrite {
  private attempt?: { path: string; body: string };
  sending = false;
  uncertain = false;
  get frozen() { return this.sending || this.uncertain; }

  constructor(
    private readonly send: (path: string, options: RequestInit) => Promise<unknown> = api,
    private readonly createId: () => string = newRequestId,
  ) {}

  async submit<T>(path: string, values: () => object): Promise<T> {
    if (this.sending) throw new Error('Speichervorgang läuft bereits.');
    this.attempt ??= { path, body: JSON.stringify({ ...values(), requestId: this.createId() }) };
    this.sending = true;
    try {
      const result = await this.send(this.attempt.path, { method: 'POST', body: this.attempt.body });
      this.attempt = undefined; this.uncertain = false;
      return result as T;
    } catch (error) {
      // A replay rejected before checking the receipt (e.g. expired login) cannot resolve a lost response.
      const rejectedBeforeAmbiguity = !this.uncertain && error instanceof ApiError && error.status < 500 && error.status !== 408 &&
        error.code !== 'request_in_progress' && error.code !== 'busy';
      const resolvedRejection = error instanceof ApiError &&
        ((error.status === 400 && error.code === 'validation') || (error.status === 409 && error.code === 'stale_record'));
      if (rejectedBeforeAmbiguity || resolvedRejection) { this.attempt = undefined; this.uncertain = false; }
      else this.uncertain = true;
      throw error;
    } finally { this.sending = false; }
  }
}
